// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adminBtnBaseDropZoneContainer .filepicker {
    background-color: transparent;
    min-height: 50px;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: var(--font-family-base);
}

.adminBtnBaseDropZoneContainer .filepicker .dz-message {
    display: none;
}

.adminBtnBaseDropZoneContainer {
    position: relative;
}

.adminBtnBaseDropZoneContainer .dz-hidden-input {
    z-index: -1;
}

@media screen and (max-width: 767px) {
    .adminBtnBaseDropZoneContainer .filepicker {
        font-size: 14px;
    }
}

/* Home Banner Setting start */

.adminBoxBaseDropZoneContainer {
    margin-bottom: 30px;
    z-index: 1;
    cursor: pointer;
    text-align: center;
}

.adminBoxBaseDropZoneContainer .filepicker {
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background-color: transparent;
    min-height: 300px;
    border: 2px dotted var(--primary-border);
    font-family: var(--font-family-base);
}

.adminBoxBaseDropZoneContainer .filepicker .dz-message {
    display: none;
}

.adminBoxBaseDropZoneContainer .dz-hidden-input {
    z-index: -1;
}

.adminBoxBaseDropZoneIcon {
    position: absolute;
    top: calc(50% - 19px);
    left: 50%;
    transform: translate(-50%, -50%);
    width: 38px;
    height: 38px;
    z-index: -1;
}

.adminBoxBaseDropZonePlaceholder {
    position: absolute;
    top: calc((50% + 11px));
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    margin-top: 12px;
    color: var(--secondary-foreground);
    z-index: -1;
    padding: 0 12px;
}

.adminBoxBaseDropZoneContainer .filepicker.dz-started+.adminBoxBaseDropZonePlaceholder,
.adminBoxBaseDropZoneContainer .filepicker.dz-started .adminBoxBaseDropZoneIcon {
    display: none;
}

.adminBoxBaseDropZoneContainer .dz-preview.dz-image-preview {
    background: transparent;
}

.adminBoxBaseDropZoneContainer .dz-preview .dz-details .dz-filename:hover {
    overflow: hidden;
    text-overflow: ellipsis;
}

@media (max-width: 480px) {
    .adminBoxBaseDropZonePlaceholder {
        top: calc((50% + 22px));
    }
}

/* Home Banner Setting end */`, "",{"version":3,"sources":["webpack://./src/styles/adminDropzone.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oCAAoC;AACxC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA,8BAA8B;;AAE9B;IACI,mBAAmB;IACnB,UAAU;IACV,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,6BAA6B;IAC7B,iBAAiB;IACjB,wCAAwC;IACxC,oCAAoC;AACxC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,gBAAgB;IAChB,kCAAkC;IAClC,WAAW;IACX,eAAe;AACnB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ;;AAEA,4BAA4B","sourcesContent":[".adminBtnBaseDropZoneContainer .filepicker {\n    background-color: transparent;\n    min-height: 50px;\n    border: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-family: var(--font-family-base);\n}\n\n.adminBtnBaseDropZoneContainer .filepicker .dz-message {\n    display: none;\n}\n\n.adminBtnBaseDropZoneContainer {\n    position: relative;\n}\n\n.adminBtnBaseDropZoneContainer .dz-hidden-input {\n    z-index: -1;\n}\n\n@media screen and (max-width: 767px) {\n    .adminBtnBaseDropZoneContainer .filepicker {\n        font-size: 14px;\n    }\n}\n\n/* Home Banner Setting start */\n\n.adminBoxBaseDropZoneContainer {\n    margin-bottom: 30px;\n    z-index: 1;\n    cursor: pointer;\n    text-align: center;\n}\n\n.adminBoxBaseDropZoneContainer .filepicker {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    background-color: transparent;\n    min-height: 300px;\n    border: 2px dotted var(--primary-border);\n    font-family: var(--font-family-base);\n}\n\n.adminBoxBaseDropZoneContainer .filepicker .dz-message {\n    display: none;\n}\n\n.adminBoxBaseDropZoneContainer .dz-hidden-input {\n    z-index: -1;\n}\n\n.adminBoxBaseDropZoneIcon {\n    position: absolute;\n    top: calc(50% - 19px);\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 38px;\n    height: 38px;\n    z-index: -1;\n}\n\n.adminBoxBaseDropZonePlaceholder {\n    position: absolute;\n    top: calc((50% + 11px));\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 100%;\n    margin-top: 12px;\n    color: var(--secondary-foreground);\n    z-index: -1;\n    padding: 0 12px;\n}\n\n.adminBoxBaseDropZoneContainer .filepicker.dz-started+.adminBoxBaseDropZonePlaceholder,\n.adminBoxBaseDropZoneContainer .filepicker.dz-started .adminBoxBaseDropZoneIcon {\n    display: none;\n}\n\n.adminBoxBaseDropZoneContainer .dz-preview.dz-image-preview {\n    background: transparent;\n}\n\n.adminBoxBaseDropZoneContainer .dz-preview .dz-details .dz-filename:hover {\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n@media (max-width: 480px) {\n    .adminBoxBaseDropZonePlaceholder {\n        top: calc((50% + 22px));\n    }\n}\n\n/* Home Banner Setting end */"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
